import "./LandingPageContainer.css"

import React, {forwardRef, useEffect} from 'react';
import Box from "@mui/material/Box";

const LandingPageContainer = forwardRef(({children}, ref) => {


    return (
    <Box className={"landing_page_container"} ref={ref} sx={{
        padding: {xs: '40px 16px 40px', md: "40px 120px 40px"},
        width: "100%",
        boxSizing: "border-box"
    }}>{children}</Box>
)});

export default LandingPageContainer;